<template>
  <div>
    <div class="app-top">
      <top-title :dataList="topTitleList" :height="300"></top-title>
    </div>
    <div class="container">
      <div class="box" v-loading="loading">
        <div class="row">
          <!-- 单机，电脑版 -->
          <div class="col-12 col-md-6 col-lg" v-if="softPrice.alone_PC_Year_Price||softPrice.alone_PC_Forever_Price">
            <div class="col-box">
              <div
                class="title"
                :style="{background:`linear-gradient(306deg, rgba(${utils.hexToRgb(softPrice.softThemeColor)},0.5), rgba(${utils.hexToRgb(softPrice.softThemeColor)},1))`+' !important'}"
              >
                单机
                <span class="tag">电脑版</span>
              </div>
              <div class="desc">
                永久激活码
                <br />适合日常固定电脑用，可换电脑
              </div>
              <div class="row price">
                <div class="col" v-if="softPrice.alone_PC_Year_Price">
                  <p class="amount">{{softPrice.alone_PC_Year_Price}}</p>
                  <p>1年</p>
                </div>
                <div class="col" v-if="softPrice.alone_PC_Forever_Price">
                  <p class="amount">{{softPrice.alone_PC_Forever_Price}}</p>
                  <p>不限时间</p>
                </div>
              </div>
              <div class="buy">
                <div
                  @click="clickBuy('Client_PC')"
                  class="btn2"
                  :style="{background:`linear-gradient(306deg, rgba(${utils.hexToRgb(softPrice.softThemeColor)},0.5), rgba(${utils.hexToRgb(softPrice.softThemeColor)},1))`}"
                >立即购买</div>
                <div
                  @click="goUrl(`http://www.veidsoft.com/DownloadFile?soft=${utils.getProductCode()}&file=${utils.getProductCode()}&ext=exe`)"
                  class="my-m-t-10 btn2"
                  :style="{background:`linear-gradient(306deg,#B2EABF, #74D689)`}"
                >下载试用</div>
              </div>
            </div>
          </div>

          <!-- 单机，优盘版 -->
          <div class="col-12 col-md-6 col-lg" v-if="softPrice.alone_UPAN_Forever_Price">
            <div class="col-box">
              <div
                class="title"
                :style="{background:`linear-gradient(306deg, rgba(${utils.hexToRgb(softPrice.softThemeColor)},0.5), rgba(${utils.hexToRgb(softPrice.softThemeColor)},1))`+' !important'}"
              >
                单机
                <span class="tag">U盘版</span>
              </div>
              <div class="desc">
                邮寄U盘，内置软件，即插即用
                <br />适合家里、公司来回切换使用
              </div>
              <div class="row price">
                <div class="col">
                  <p class="amount">{{softPrice.alone_UPAN_Forever_Price}}</p>
                  <p>不限时间</p>
                </div>
              </div>
              <div class="buy">
                <div
                  @click="clickBuy('Client_USB')"
                  class="btn2"
                  :style="{background:`linear-gradient(306deg, rgba(${utils.hexToRgb(softPrice.softThemeColor)},0.5), rgba(${utils.hexToRgb(softPrice.softThemeColor)},1))`}"
                >立即购买</div>
                <div
                  @click="goUrl(`http://www.veidsoft.com/DownloadFile?soft=${utils.getProductCode()}&file=${utils.getProductCode()}&ext=exe`)"
                  class="my-m-t-10 btn2"
                  :style="{background:`linear-gradient(306deg,#B2EABF, #74D689)`}"
                >下载试用</div>
              </div>
            </div>
          </div>
          <!-- 单机，加密狗版 -->
          <!-- <div class="col-12 col-md-6 col-lg" v-if="softPrice.alone_DOG_Forever_Price">
            <div class="col-box">
              <div class="title" :style="{backgroundColor:`rgb(${utils.hexToRgb(softPrice.softThemeColor)},0.8)`+' !important'}">
                单机版
                <span class="tag">加密狗版</span>
              </div>
              <div class="desc">
                邮寄加密狗，不限电脑
                <br />适合个人，可换电脑使用
              </div>
              <div class="row price">
                <div class="col">
                  <p class="amount">{{softPrice.alone_DOG_Forever_Price}}</p>
                  <p>不限时间</p>
                </div>
              </div>
              <div class="buy">
                <div
                  @click="clickBuy('Client_DOG')"
                  class="btn2"
                  :style="{background:`linear-gradient(306deg, rgba(${utils.hexToRgb(softPrice.softThemeColor)},0.5), rgba(${utils.hexToRgb(softPrice.softThemeColor)},1))`}"
                >立即购买</div>
                <div
                  @click="goUrl(`http://www.veidsoft.com/DownloadFile?soft=${utils.getProductCode()}&file=${utils.getProductCode()}&ext=exe`)"
                  class="my-m-t-10 btn2"
                  :style="{background:`linear-gradient(306deg,#B2EABF, #74D689)`}"
                >下载试用</div>
              </div>
            </div>
          </div>-->
          <!-- 网络版 -->
          <div class="col-12 col-md-6 col-lg" v-if="softPrice.net_Year_Price||softPrice.net_Forever_Price">
            <div class="col-box">
              <div
                class="title"
                :style="{background:`linear-gradient(306deg, rgba(${utils.hexToRgb(softPrice.softThemeColor)},0.5), rgba(${utils.hexToRgb(softPrice.softThemeColor)},1))`+' !important'}"
              >网络版</div>
              <div class="desc">
                手机+电脑，数据同步
                <br />适合多人、多设备、同时使用
              </div>
              <div class="row price">
                <div class="col" v-if="softPrice.net_Year_Price">
                  <p class="amount oneuser">{{softPrice.net_Year_Price}}</p>
                  <p>1年</p>
                </div>
                <div class="col" v-if="softPrice.net_Forever_Price">
                  <p class="amount oneuser">{{softPrice.net_Forever_Price}}</p>
                  <p>不限时间</p>
                </div>
              </div>
              <div class="buy">
                <div
                  @click="clickBuy('Network')"
                  class="btn2"
                  :style="{background:`linear-gradient(306deg, rgba(${utils.hexToRgb(softPrice.softThemeColor)},0.5), rgba(${utils.hexToRgb(softPrice.softThemeColor)},1))`}"
                >立即购买</div>
                <div
                  @click="goUrl(`${softPrice.softWebUrl }/register`)"
                  class="my-m-t-10 btn2"
                  :style="{background:`linear-gradient(306deg,#B2EABF, #74D689)`}"
                >免费体验</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import API_Soft from '@/api/soft'
import topTitle from '@/_myComponents/topTitle'

export default {
  components: { topTitle },
  name: 'Price',
  data() {
    return {
      loading: false,
      topTitleList: [],
      versionList: []
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['softPrice'])
  },
  mounted() {},
  created() {
    this.utils.refreshSoftPrice(this.onloadArgs.getInvite())
    ;(this.topTitleList = [
      {
        image: '',
        title: '价格',
        subTitle: '单机版、网络版，灵活选择',
        backgroundImage: require('@/assets/images/bg/bg-5.jpg'),
        backgroundColor: `linear-gradient(rgba(${this.utils.hexToRgb(this.softPrice.softThemeColor)},0.5),rgba(${this.utils.hexToRgb(
          this.softPrice.softThemeColor
        )},0.1))`
      }
    ]),
      this.getVersionList()
  },
  methods: {
    clickBuy(licenseType) {
      console.log(licenseType)
      if (licenseType == 'Network') {
        if (this.versionList.length > 0) {
          this.$router.push({ name: 'NetworkPrice' })
        } else {
          this.$router.push({ name: 'BuyNetwork' })
        }
      } else {
        this.$router.push({ name: 'BuyAlone', params: { licenseType: licenseType } })
      }
      // this.$router.push({ name: 'Buy', params: { licenseType: licenseType } })
    },
    goUrl(url) {
      window.open(url, '_blank ')
    },

    //获取版本列表
    getVersionList() {
      this.loading = true
      API_Soft.getVersions({
        product: this.utils.getProductCode(),
        licenseType: 'Network'
      }).then(res => {
        this.loading = false
        this.versionList = res.data.list
        // this.diffList = res.data.diffs_new
        // this.introList = res.data.intros
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// --------------------移动端--------------------
@media screen and (max-width: 576px) {
  .container {
    font-size: 12px;

    button {
      font-size: 12px !important;
      padding: 10px !important;
    }

    .box {
      margin: 10px !important;

      .col-box {
        border: 1px #dddddd solid !important;
        padding-bottom: 20px !important;
        margin: 10px 0 !important;
        // background: red !important;

        .title {
          font-size: 26px !important;
          // font-weight: 600;
          // background: cornsilk;
        }

        .desc {
          padding-top: 20px !important;
          height: auto !important;
        }

        .price {
          padding-bottom: 10px !important;
          height: auto !important;
        }
      }
    }
  }
}

// --------------------电脑端--------------------
.app-top {
  margin-top: 58px;
}

.container {
  background: #f8f8f8;

  .box {
    background: #f8f8f8;
    margin-top: 30px;
    margin-bottom: 30px;

    .col-box {
      border: 1px solid #fff;
      background: #fff;
      margin: 30px 0;
      padding: 0 0 50px 0;

      .title {
        text-align: center;
        color: #333;
        font-size: 22px;
        // font-weight: 600;
        color: #fff;
        // background-color: rgba(0, 0, 0, 0.1);
        padding: 15px 0;
      }

      .desc {
        text-align: center;
        height: 80px;
        padding-top: 20px;
        color: #888;
        font-size: 14px;
      }

      .price {
        text-align: center;
        color: #000;
        height: 130px;
        padding-top: 20px;

        // display: flex;
        // flex-direction: row;
        // align-items: center;
        .amount {
          color: #f56c6c;
          font-size: 26px;
          font-weight: bold;
        }

        .amount::before {
          content: '￥';
          font-weight: lighter;
          font-size: 16px;
        }

        .oneuser::after {
          content: '起';
          font-weight: lighter;
          font-size: 12px;
          color: #ccc;
        }

        p {
          margin-bottom: 0px;
          color: #999;
          font-size: 14px;
        }
      }

      .buy {
        text-align: center;
        color: #000;

        a,
        button {
          margin-bottom: 10px;
          font-size: 14px;
          width: 80%;
        }
      }

      .tag {
        padding: 2px 5px;
        font-size: 20px;
        font-weight: lighter;
        color: #fff;
        // background: #fff;
        border: 1px #fff solid;
        border-radius: 5px;
      }
    }
  }

  .col-box:hover {
    // margin-top: -10px;
    border: 1px solid rgba(175, 182, 185, 0.514);
    box-shadow: 0px 0px 26px rgba(175, 182, 185, 0.25);
  }
}
</style>